<template>
  <div>
    <VSelect
      v-model="status"
      :items="statuses"
      item-text="name"
      item-value="status"
      outlined
      dense
      hide-details
      class="body-2"
      :disabled="readonly"
      @change="onUpdate"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import useCandidates from '@/compositions/useCandidates';
import useStatus from '@/compositions/useStatus';
import {
  computed, ref, toRefs, watchEffect,
} from '@vue/composition-api';
import { candidateStatus } from '../../enums';

export default {
  name: 'CandidateStatusPanel',
  components: { },
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { candidate } = toRefs(props);
    const { useActions, useState } = createNamespacedHelpers('kanban');
    const { fetch } = useActions(['fetch']);
    const { statuses, fetchAllStatuses } = useStatus();

    const { useMutations } = createNamespacedHelpers('candidatePage');
    const { setNotificationType } = useMutations(['setNotificationType']);
    const { stages } = useState(['stages']);

    if (!statuses.value) {
      fetch();
    }

    fetchAllStatuses();

    const { updateStatus, resolveNotificationTypeFromStatus } = useCandidates();
    const status = ref(null);

    watchEffect(() => {
      status.value = candidate.value?.status;
    });

    function canStatusShow(s) {
      if (status.value !== candidateStatus.IMPORTED
        && s.status === candidateStatus.IMPORTED) {
        return false;
      }

      if (status.value === candidateStatus.IMPORTED
        && s.status === candidateStatus.INVITED) {
        return true;
      }
      return !(status.value !== candidateStatus.INVITED
        && s.status === candidateStatus.INVITED);
    }

    const statusSelectItems = computed(() => {
      return stages.value?.filter(canStatusShow);
    });

    async function updateCandidateStatus(s) {
      const notificationTypeVal = resolveNotificationTypeFromStatus(s);
      if (notificationTypeVal) {
        setNotificationType(notificationTypeVal);
      }

      await updateStatus(candidate.value.id, s);
    }

    return {
      status,
      statusSelectItems,
      candidateStatus,
      statuses,
      done() {
        updateCandidateStatus(candidateStatus.INVITED);
      },
      cancel() {
        status.value = candidate.value.status;
      },
      async onUpdate(s) {
        await updateCandidateStatus(s);
      },
    };
  },
};
</script>

<i18n locale="en" lang="yaml">
  imported: Imported
  invited: Invited
  interviewed: Passed the interview
  inoffice_interview: Invited for an in-office interview
  job_offer: Job offer
  hired: Hired
  declined: Declined
</i18n>

<i18n locale="ru" lang="yaml">
  imported: Импортирован
  invited: Приглашение отправлено
  interviewed: Прошел интервью
  inoffice_interview: Приглашен на очное интервью
  job_offer: Предложение о работе
  hired: Выход на работу
  declined: Отказ
</i18n>
